import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState, useRef} from "react";
import {Button} from "react-bootstrap";


const TopBarActions = ({actions, filtersRef, className, style = {}}) => {
    const activesDefault = {
        edit: false,
        add: false,
        addPlus: false,
        export: false,
        delete: false,
        editColumn: false,
        filter: false,
        trash: false
    }
    const [actives, setActives] = useState(activesDefault);
    const notAction = ["title", "searcher", "counter"]
    const filters = filtersRef?.current || null;
    const classApply = useRef("navbar navbar-expand w-100")
    useEffect(()=>{
        if (className) {
            classApply.current += " " + className
        }
    }, [])

    useEffect(() => {

        for (let action in actions) {
            if (notAction.includes(action)) {
                continue;
            }
            setActives((data) => ({...data, [action]: actions[action].active}));
        }
    }, [actions])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (filters && filters.searcher.ref) {
            filters.onChangeSearcher(filters.searcher.ref.value);
        }
    };

    const handleInput = (e) => {
        if (e.target.value === '' && filters) {
            filters.onChangeSearcher('');
        }
    };

    // Función para asignar la referencia al input
    const setSearcherRef = (element) => {
        if (filters) {
            filters.searcher.ref = element;
        }
    };

    return (
        <>
            <nav className={classApply.current} style={style}>
                <div className="d-flex m-2 ms-5 w-100">
                    <div className="navbar-brand me-2">{actions.title}</div>
                    <button className="navbar-toggler " type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent " aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div id="navbarSupportedContent" className="w-100">
                        <ul className="navbar-nav ">
                            {actives.edit ?
                                < li className="nav-item me-2">
                                    <Button variant="link" type="button" onClick={actions.edit.onClick}
                                            disabled={actions.edit.disabled}>
                                        <FontAwesomeIcon icon="fa-pen"/>
                                    </Button>
                                </li>
                                : <>  </>}
                            {actives.add ?
                                <li className="nav-item me-2">
                                    <Button variant="link" type="button" onClick={actions.add.onClick}
                                            disabled={actions.add.disabled}>
                                        <FontAwesomeIcon icon="fa-plus"/>
                                    </Button>
                                </li>
                                : <>  </>}
                            {actives.addPlus ?
                                <li className="nav-item me-2">
                                    <Button variant="link" type="button" onClick={actions.addPlus.onClick}>
                                        <FontAwesomeIcon icon="fa-bars"/>
                                    </Button>

                                </li>
                                : <>  </>}
                            {actives.export ?
                                <li className="nav-item me-2">
                                    <Button variant="link" type="button" onClick={actions.export.onClick}>
                                        <FontAwesomeIcon icon="fa-file-export"/>
                                    </Button>

                                </li>
                                : <>  </>}
                            {actives.delete ?
                                <li className="nav-item me-2">
                                    <Button variant="link" type="button" onClick={actions.delete.onClick}
                                            disabled={actions.delete.disabled}>
                                        <FontAwesomeIcon icon="fa-trash"/>
                                    </Button>
                                </li>
                                : <>  </>}
                            {actives.editColumn ?
                                <li className="nav-item me-2">
                                    <Button variant="link" type="button"
                                            aria-controls="columns-selector"
                                            aria-expanded={actions.editColumn.status}
                                            onClick={actions.editColumn.onClick}>
                                        <FontAwesomeIcon icon="fa-solid fa-table-columns"/>
                                    </Button>
                                </li>
                                : <>  </>}

                            {actives.filter ?
                                <li className="nav-item me-2">
                                    <Button variant="link" type="button" onClick={actions.filter.onClick}
                                            aria-controls="filter-collapse"
                                            aria-expanded="false"
                                            style={
                                                actions.filter.applied
                                                    ? !actions.filter.click ? {color: 'orange'} : {color: 'green'}
                                                    : !actions.filter.click ? {color: ''} : {color: 'green'}
                                            }
                                    >
                                        <FontAwesomeIcon icon="fa-solid fa-filter"/>
                                    </Button>
                                </li>
                                : <></>}

                            {actives.trash ?
                                <li className="nav-item me-2">
                                    <Button variant="link" type="button" onClick={actions.trash.onClick}
                                            disabled={actions.trash.disabled}>
                                        <FontAwesomeIcon icon="fa-solid fa-trash-arrow-up"/>
                                    </Button>
                                </li>
                                : <></>}

                            {actives.topBack ?
                                <li className="nav-item me-2">
                                    <Button variant="link" type="button" onClick={actions.topBack.onClick}
                                            disabled={actions.topBack.disabled}>
                                        <FontAwesomeIcon icon="fa-solid fa-arrow-turn-up" transform={{rotate: -90}}/>
                                    </Button>
                                </li>
                                : <></>}

                            {actives.settings ?
                                <li className="nav-item me-2">
                                    <Button variant="link" type="button" onClick={actions.settings.onClick}
                                            disabled={actions.settings.disabled}>
                                        <FontAwesomeIcon icon="fa-solid fa-gear" style={{color: "black"}}/>
                                    </Button>
                                </li>
                                : <></>}

                            <form
                                className="d-flex ms-auto"
                                role="search"
                                onSubmit={handleSubmit}>
                                <input
                                    className="form-control border-end-0 rounded-0"
                                    type="search"
                                    id="topbar-searcher"
                                    placeholder="Buscar"
                                    aria-label="Buscar"
                                    ref={setSearcherRef}
                                    onInput={handleInput}
                                />
                                <span className="input-group-text bg-white border-start-0 rounded-0">
                                    <FontAwesomeIcon icon="fa-solid fa-magnifying-glass"/>
                                </span>
                            </form>
                        </ul>
                    </div>
                </div>
            </nav>
        </>

    )
}

export default TopBarActions



